import Vue from "vue";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    GroupsList: [],
    CurrentGroupId: "",
    ShowGroupWizard: false,
    AllGroups: [],
    GroupWizardModalInfo: {
      data: null,
      show: false
    }
  };
}

const state = initialState();

const actions = {
  getGroupsByFilter: function(context, params) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/core/groups/searchgroup", params)
        .then(function(data) {
          context.commit("UpdateGroupList", data.data.Data);
          resolve(data.data ? data.data.Data : []);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllGroups: function(context, request) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("core/groups/filtergroup", request)
        .then(data => {
          if (data && data.data) resolve(data.data.Data ? data.data.Data : []);
          context.commit("UpdateAllGroups", data.data.Data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateGroupWizardModalInfo(context, data) {
    context.commit("updateGroupWizardModalInfo", data);
  }
};

const mutations = {
  UpdateAllGroups: function(state, data) {
    state.AllGroups = data.sort(HelperFunctions.sortByProperty("GroupName"));
  },
  UpdateGroupList: function(state, data) {
    state.GroupsList = data;
  },
  UpdateCurrentGroupId: function(state, data) {
    state.CurrentGroupId = data;
  },
  toggleGroupWizard: function(state, data) {
    state.ShowGroupWizard = data;
  },
  updateGroupWizardModalInfo(state, data) {
    state.GroupWizardModalInfo = data;
  }
};

const getters = {
  GroupsList: function() {
    return state.GroupsList;
  },
  CurrentGroupId: function() {
    return state.CurrentGroupId;
  },
  ShowGroupWizard: function() {
    return state.ShowGroupWizard;
  },
  AllGroups: function() {
    return state.AllGroups;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/GroupList.js